import { render } from "./DetailsOfBuyer.vue?vue&type=template&id=3f92d075&scoped=true"
import script from "./DetailsOfBuyer.vue?vue&type=script&lang=js"
export * from "./DetailsOfBuyer.vue?vue&type=script&lang=js"

import "./DetailsOfBuyer.vue?vue&type=style&index=0&id=3f92d075&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f92d075"]])

export default __exports__